var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"homePage"},[_c('MainSection'),_c('Features'),_c('AboutUs'),_c('Services'),_c('Works'),_c('Technology'),_c('ContactUs'),_c('Partners')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }